﻿import type { Ref } from 'vue'
import type { TInvestorCategory } from '@/domains/investor/const/InvestorCategories.const'
import type { IDataViewCategoryScope } from '@/domains/investor/components/DataView/DataView.types'
import { useDataViewFilters } from '@/domains/investor/components/DataView/DataViewFilters/DataViewFilters.composable'
import { GENERAL_MEETING_CATEGORIES_SCOPE } from '@/domains/investor/general-meeting/const/generalMeeting.const'
import { useDataView } from '@/domains/investor/components/DataView/DataView.composable'

const { fetchList } = useDataView()

export const useGeneralMeetingFilters = (
  category: Ref<TInvestorCategory>,
  year: Ref<number[]>,
  months: Ref<number[]>,
  options: {
    enableSearch?: boolean
    categoryScope?: IDataViewCategoryScope
  } = {},
) => {
  const categoryScope = {
    ...GENERAL_MEETING_CATEGORIES_SCOPE,
    ...options.categoryScope,
    allSecondCategories: options.categoryScope?.allSecondCategories
      ?? options.categoryScope?.allowedSecondCategories
      ?? GENERAL_MEETING_CATEGORIES_SCOPE.allowedSecondCategories,
  }

  return useDataViewFilters(category, year, months, {
    enableSearch: options.enableSearch,
    categoryScope,
    fetchSuggestions: async params => {
      const { reports } = await fetchList(params)

      return reports.map(report => ({ value: report.url, label: report.title }))
    },
  })
}
